// src/GameMaker/LexGameMaker.jsx
import React, { useState } from "react";
import "./LexGameMaker.css";

const GAME_CATEGORIES = [
  {
    category: "🎮 Entertainment / Marketing",
    desc: "For fun and interactive campaigns",
    games: [
      { id: 1, name: "Word Guess", desc: "Wordle-style game with limited attempts" },
      { id: 2, name: "Reaction Tap", desc: "Click targets fast within time limit" },
      { id: 3, name: "Card Match", desc: "Memory game to match card pairs" },
      { id: 4, name: "Spot the Difference", desc: "Find differences between two images" },
      { id: 5, name: "Connect Icons", desc: "Drag to match icons with lines" },
      { id: 6, name: "Drag to Sort", desc: "Sort items by preference or logic" },
      { id: 7, name: "Puzzle Game", desc: "Reconstruct the image by dragging pieces" },
      { id: 8, name: "Runner Game", desc: "Tap to jump and dodge, collect points" }
    ]
  },
  {
    category: "📘 Educational / Knowledge",
    desc: "For testing and learning",
    games: [
      { id: 9, name: "Quiz", desc: "Multiple or single choice questions" },
      { id: 10, name: "True or False", desc: "Decide if statements are correct" },
      { id: 11, name: "Fill in the Blank", desc: "Type missing words or labels" },
      { id: 12, name: "Line Match", desc: "Connect concepts to definitions" },
      { id: 13, name: "Logic Sort", desc: "Reorder scrambled logic steps" },
      { id: 14, name: "Stage Quiz", desc: "Clear stages by answering questions correctly" }
    ]
  },
  {
    category: "🛠 Product / Interaction",
    desc: "For surveys and experience customization",
    games: [
      { id: 15, name: "Preference Picker", desc: "Tap preferred items to collect preferences" },
      { id: 16, name: "Drag Classifier", desc: "Drag items into category areas" },
      { id: 17, name: "Voting Poll", desc: "Vote quickly between choices" },
      { id: 18, name: "Emoji Feedback", desc: "Pick an emoji to express feeling" }
    ]
  }
];

export default function LexGameMaker() {
  const [showBuilder, setShowBuilder] = useState(false);
  const [page, setPage] = useState(0);
  const total = GAME_CATEGORIES.length;

  const prevPage = (page - 1 + total) % total;
  const nextPage = (page + 1) % total;
  const visible = [prevPage, page, nextPage];

  const handleCardClick = (role) => {
    if (role === "left") setPage(prevPage);
    else setPage(nextPage);
  };

  // Initial launch button view
  if (!showBuilder) {
    return (
      <div className="builder-launch">
        <button className="launch-btn" onClick={() => setShowBuilder(true)}>
          No-Code Gamer Builder
          <div className="tagline">build your own game in minutes</div>
        </button>
      </div>
    );
  }

  // Carousel view with close button
  return (
    <div className="builder-container">
      <button className="close-btn" onClick={() => setShowBuilder(false)}>✕</button>

      <div className="carousel-container">
        <div className="cards-wrapper">
          {visible.map((idx, pos) => {
            const cat = GAME_CATEGORIES[idx];
            const role = pos === 1 ? "active" : pos === 0 ? "left" : "right";
            return (
              <div
                key={cat.category}
                className={`category-card ${role}`}
                onClick={() => handleCardClick(role)}
              >
                <h2>{cat.category}</h2>
                <p>{cat.desc}</p>
                <div className="game-table">
                  <table>
                    <thead>
                      <tr><th>Name</th><th>Description</th></tr>
                    </thead>
                    <tbody>
                      {cat.games.map((g) => (
                        <tr key={g.id}><td>{g.name}</td><td>{g.desc}</td></tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            );
          })}
        </div>  
      </div>
    </div>
  );
}

// END OF FILE
